import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, } from 'react-bootstrap';
import { Toast, } from '@payit/cool-web-ui-library';
import Confirm from '../../confirm/Confirm';
import { buildFailureStatus, buildSuccessStatus, } from '../../constants/AlertConstants';
import AsyncActionButton from '../../button/AsyncActionButton';
import RefundStrategy from './RefundStrategy';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import { V2, } from '../../../modules/Constants';
import { STANDARD_REFUND, } from './Constants';

class FullRefundOperation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      items: [],
      isReady: true,
      isConfirmationOpen: false,
      status: null,
      refundedTransactionId: '',
    };
    const { data, } = this.props;
    const { transaction, } = data;

    if (data.refundMethod === STANDARD_REFUND) {
      this.setState({
        isReady: false,
      });
      RefundStrategy.getPaidItems(transaction)().then((payload) => {
        this.setState({
          items: payload,
          isReady: true,
        });
      });
    }
  }

  onDismiss() {
    return () => {
      this.setState({
        status: null,
      });
    };
  }

  onConfirmationOpen() {
    this.setState({
      isConfirmationOpen: true,
    });
  }

  onConfirmationClose() {
    this.setState({
      isConfirmationOpen: false,
    });
  }

  onSuccessfulPOSRefund(data) {
    const { subpayments, } = data;
    const creditTransactions = subpayments
      .filter(subpayment => subpayment.transactionType === 'CREDIT');
    if (creditTransactions.length === 1) {
      const refundedTransaction = creditTransactions[0];
      this.setState({
        status: buildSuccessStatus(
          ` Refunded transaction id: ${refundedTransaction.btpsTransactionId} for ${
            refundedTransaction.chargedAmount.amount} ${refundedTransaction.chargedAmount.currencyCode}`,
          this.onDismiss()
        ),
        refundedTransactionId: refundedTransaction.btpsTransactionId,
      });
    }
  }

  onSuccessfulRefund(data, version) {
    if (version === V2) {
      const { chargedAmount = {}, } = data;
      this.setState({
        status: buildSuccessStatus(
          ` Refunded transaction id: ${data._id} for ${chargedAmount.amount} ${
            chargedAmount.currencyCode
          }`,
          this.onDismiss()
        ),
        refundedTransactionId: data._id,
      });
    } else {
      const { refund, } = data;
      this.setState({
        status: buildSuccessStatus(` Refunded transaction id: ${refund._id}`, this.onDismiss()),
        refundedTransactionId: refund._id,
      });
    }
  }

  copyRefundedTransactionIdToClipboard(transactionId) {
    navigator.clipboard.writeText(transactionId);
    Toast.showToast({
      contentType: Toast.CONTENT_TYPES.SUCCESS,
      autoHide: true,
      autoHideDelay: 2000,
      text: 'Copied to clipboard',
      detail: `Transaction ID ${transactionId} copied to clipboard`,
    });
  }

  showCopyButton(transactionId, status) {
    if (status && status.props.alertVariant === 'success' && this.state.refundedTransactionId !== '') {
      return (
        <button type="button" className="btn btn-light" onClick={() => this.copyRefundedTransactionIdToClipboard(transactionId)}>
          Copy Refunded Transaction ID to Clipboard
        </button>
      );
    }
    return null;
  }

  refund() {
    if (this.props.data.refundMethod === 'REFUND_SERVICE_REFUND') {
       
      alert('Athos support for full refunds through Refund Service has not been implemented yet.');
      this.props.back();
      return;
    }

    this.setState({ isLoading: true, });
    const { data = {}, } = this.props;
    const { transaction, } = data;
    const builder = RefundStrategy.Builder();
    this.setState({
      status: null,
    });

    builder
      .version(transaction.version)
      .refundMethod(data.refundMethod)
      .refundType(data.refundType)
      .payload(transaction)
      .isPos(data.posRefund)
      .build()
      .refund()
      .then((res) => {
        if (data.posRefund) {
          this.onSuccessfulPOSRefund(res.data.data, transaction.version);
        } else {
          this.onSuccessfulRefund(res.data, transaction.version);
        }
      })
      .catch(({ response, }) => {
        const errors = data.posRefund ? response.data.errors.map(error => error.data.message)
          : response.data.errors.map(error => error.message);
        this.setState({
          status: buildFailureStatus(
            <div>
              <p>{`Unable to refund ${transaction.id}`}</p>
              <hr />
              {errors.map((e, index) => (
                <p key={`error-${index}`}>{e}</p>
              ))}
            </div>,
            this.onDismiss()
          ),
        });
      })
      .finally(() => {
        this.setState({ isLoading: false, });
        this.onConfirmationClose();
      });
  }

  render() {
    const {
      isLoading, isConfirmationOpen, status, items = [], isReady, refundedTransactionId,
    } = this.state;
    const { data = {}, back, reset, } = this.props;
    const { transaction, } = data;
    const model = Grid.toModelFromList(items);
    if (!isReady) {
      return (
        <div className="justify-content-center">
          <Spinner animation="border" />
        </div>
      );
    }
    return (
      <div>
        {data.getDetails()}
        {status}
        <FieldSet title="Refund Item Summary">
          <Grid headers={model.headers} rows={model.format(items)} />
        </FieldSet>

        <Confirm
          isLoading={isLoading}
          title="Refund"
          content={`Are you sure you want to want to refund transaction: ${transaction.id}?`}
          open={isConfirmationOpen}
          onClose={() => this.onConfirmationClose()}
          onYes={() => this.refund(transaction)}
          onNo={() => this.onConfirmationClose()}
        />

        <div className="row justify-content-center mt-3">
          <button type="button" className="btn btn-light" onClick={() => back()}>
            previous
          </button>
          <AsyncActionButton
            isLoading={isLoading}
            onClick={() => this.onConfirmationOpen()}
            contents="submit"
            variant="light"
          />
          <button type="button" className="btn btn-light" onClick={() => reset()}>
            reset
          </button>
        </div>

        <div className="row justify-content-center mt-3">
          {this.showCopyButton(refundedTransactionId, status)}
        </div>
      </div>
    );
  }
}

FullRefundOperation.propTypes = {
  data: PropTypes.object.isRequired,
  back: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};

export default FullRefundOperation;
